import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class PrintNode_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public PrintNode: PrintNode_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

